var hash = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

export { getOppositePlacement as g };
//# sourceMappingURL=getOppositePlacement-CK9DxKNC.js.map
